import { render, staticRenderFns } from "./TarjetaInstalacion.vue?vue&type=template&id=5cbf5128&"
import script from "./TarjetaInstalacion.vue?vue&type=script&lang=js&"
export * from "./TarjetaInstalacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports